import classNames from "classnames";
import React from "react";
import moment from "moment";

interface Props {
  week: server.dto.MiniCalendarWeek
  onWeekClicked: (week: server.dto.MiniCalendarWeek) => void
  onDayClicked: (day: server.dto.MiniCalendarDay) => void
  highlightedMonth: number
}

const today = moment.utc();

const isToday = (m: moment.Moment) => {
  return m.isSame(today, "day");
};

const WeekRow = (props: Props) => {
  const [isHoveringOverWeek, setIsHoveringOverWeek] = React.useState(false);
  const rowClasses = classNames("weekrow", {
    isHoveringOverWeek: isHoveringOverWeek
  });

  const onWeekClicked = () => {
    props.onWeekClicked(props.week);
  };

  const onDayClicked = (day: server.dto.MiniCalendarDay) => {
    props.onDayClicked(day);
  };

  return <div className={rowClasses}>
    <div
      onMouseOver={() => { setIsHoveringOverWeek(true); }}
      onMouseOut={() => { setIsHoveringOverWeek(false); }}
      onClick={onWeekClicked}
    >
      wk {props.week.week}
    </div>

    {props.week.days.map((day, idx) => {
      // Number should be between 0 and 10
      const maxGrade = Math.min(10, Math.max(0, day.count));
      const classes = classNames("minicalendar_day hoverable",
        `minicalendar_day_${maxGrade}`,
        {
          today: isToday(moment.utc(day.date)),
          isHovered: day.month === props.highlightedMonth + 1
        });

      return <div key={idx} className={classes} onClick={() => { onDayClicked(day); }}>
        {day.day}
      </div>;
    }
    )}
  </div>;
};

export default WeekRow;
